const load = async ({ params }) => {
  return {
    uuid: params.uuid
  };
};
export {
  load
};
//# sourceMappingURL=_page.ts.js.map
